import { SheetFooter } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";

interface FormSheetFooterProps {
  onCancel: () => void;
  isSubmitting?: boolean;
  // ADV-793: callers (e.g. ProposalFormSheet) sometimes want to disable the
  // submit button — e.g. while a required Select is empty — without flipping
  // the label to "Saving…". `disabled` covers that case; isSubmitting still
  // drives the in-flight label as before.
  disabled?: boolean;
  submitLabel?: string;
  formId?: string;
}

export function FormSheetFooter({
  onCancel,
  isSubmitting,
  disabled,
  submitLabel = "Save",
  formId,
}: FormSheetFooterProps) {
  return (
    <SheetFooter className="border-t pt-4">
      <Button type="button" variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button type="submit" form={formId} disabled={isSubmitting || disabled}>
        {isSubmitting ? "Saving…" : submitLabel}
      </Button>
    </SheetFooter>
  );
}
